import HoldingClassList from 'modules/partners/pages/HoldingClassList';
import { HoldingClassListPageProvider } from 'modules/partners/pages/HoldingClassList/context/HoldingClassListPageContext';

const HoldingClassListPage = () => (
  <HoldingClassListPageProvider>
    <HoldingClassList />
  </HoldingClassListPageProvider>
);

export default HoldingClassListPage;
